var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankDesposite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.002,
    height: 65,
    viewBox: "0 0 57.002 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_152495",
    "data-name": "Group 152495",
    transform: "translate(-1549.523 -201.883)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103131",
    "data-name": "Path 103131",
    d: "M56.3,43v2.665H9.665A2.665,2.665,0,0,1,7,43Z",
    transform: "translate(1548.37 217.777)",
    fill: "#284261"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103139",
    "data-name": "Path 103139",
    d: "M40.647,14.329c0,13.323-17.613,18.453-24.648,6.995a13.323,13.323,0,1,1,24.648-6.995Z",
    transform: "translate(1550.696 202.757)",
    fill: "#fc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103140",
    "data-name": "Path 103140",
    d: "M39.649,14.323A13.219,13.219,0,0,1,37.5,21.547,13.323,13.323,0,0,1,19.118,3.118a13.323,13.323,0,0,1,20.531,11.2Z",
    transform: "translate(1551.694 202.763)",
    fill: "#ffde76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103145",
    "data-name": "Path 103145",
    d: "M13.665,29c0,14.136-.133,13.323,0,13.323A2.665,2.665,0,0,1,11,39.659V29Zm17.32,0c0,14.136-.133,13.323,0,13.323a2.665,2.665,0,0,1-2.665-2.665V29Zm17.32,0c0,14.136-.133,13.323,0,13.323a2.665,2.665,0,0,1-2.665-2.665V29Z",
    transform: "translate(1548.644 212.068)",
    fill: "#284261"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103146",
    "data-name": "Path 103146",
    d: "M53.635,39.982a1.332,1.332,0,0,0,1.332-1.332v-4h2.665a1.332,1.332,0,0,0,1.332-1.332c0-3.664.293-4.676-.733-5.183l-14.1-7.048a14.656,14.656,0,1,0-26.3,0l-14.1,7.048c-.973.48-.733,1.186-.733,5.183a1.332,1.332,0,0,0,1.332,1.332H7v4a1.332,1.332,0,0,0,1.332,1.332H9.668V50.64H8.336A1.332,1.332,0,0,0,7,51.973v4H4.339A1.332,1.332,0,0,0,3.007,57.3v5.329a1.332,1.332,0,0,0,1.332,1.332H57.632a1.332,1.332,0,0,0,1.332-1.332V57.3a1.332,1.332,0,0,0-1.332-1.332H54.967v-4a1.332,1.332,0,0,0-1.332-1.332H52.3V39.982ZM52.3,37.317H44.309V34.653H52.3ZM42.976,50.64a1.332,1.332,0,0,0-1.332,1.332v4h-4v-4a1.332,1.332,0,0,0-1.332-1.332H34.982V39.982h1.332a1.332,1.332,0,0,0,1.332-1.332v-4h4v4a1.332,1.332,0,0,0,1.332,1.332h1.332V50.64ZM20.327,55.97v-4a1.332,1.332,0,0,0-1.332-1.332H17.662V39.982h1.332a1.332,1.332,0,0,0,1.332-1.332v-4h4v4a1.332,1.332,0,0,0,1.332,1.332h1.332V50.64H25.656a1.332,1.332,0,0,0-1.332,1.332v4ZM32.318,50.64H29.653V39.982h2.665ZM26.988,37.317V34.653h7.994v2.665Zm0,15.988h7.994V55.97H26.988Zm4-50.628A11.991,11.991,0,1,1,18.994,14.668,11.991,11.991,0,0,1,30.985,2.677ZM5.671,30.149l13.55-6.782c2.931,3.944,5.1,3.291,1.106,3.291a1.332,1.332,0,0,0,0,2.665H41.644a1.332,1.332,0,1,0,0-2.665c-4,0-1.825.653,1.106-3.291L56.3,30.149v1.839H5.671Zm11.991,4.5v2.665H9.668V34.653Zm-5.329,5.329H15V50.64H12.333ZM9.668,53.305h7.994V55.97H9.668ZM56.3,61.3H5.671V58.634H56.3ZM44.309,55.97V53.305H52.3V55.97Zm5.329-5.329H46.973V39.982h2.665Z",
    transform: "translate(1547.034 202.419)",
    stroke: "#284261",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103147",
    "data-name": "Path 103147",
    d: "M26.662,17.323H21.332a1.332,1.332,0,1,0,0,2.665H24V21.32a1.332,1.332,0,0,0,2.665,0V19.988a4,4,0,1,0,0-7.994H24a1.332,1.332,0,0,1,0-2.665h5.329a1.332,1.332,0,0,0,0-2.665H26.662V5.332a1.332,1.332,0,0,0-2.665,0V6.665a4,4,0,0,0,0,7.994h2.665a1.332,1.332,0,0,1,0,2.665Z",
    transform: "translate(1552.69 203.76)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankDesposite);
export default __webpack_public_path__ + "static/media/bankDesposite.910dda73b1b3e06820100d903bbb0222.svg";
export { ForwardRef as ReactComponent };